import { FormattedText } from "@tm/static";
import React from "react";
import { DateRange, DayPicker } from "react-day-picker";
import {
  CalendarDropdownWrap,
  DatePickerHeader,
  DatePickerHeaderInner,
  ErrorToast,
} from "./CommonLandingDT.style";

interface CalendarDropdownProps {
  calendarRef: React.RefObject<HTMLDivElement>;
  isSingleDate: boolean;
  selectedSegment: any;
  showToast: boolean;
  toastMessage: string;
  range?: DateRange;
  tempRange?: DateRange;
  openCalendar: string | null;
  disabledDays: (date: Date) => boolean;
  handleSingleDateSelect: (date: Date) => void;
  handleDayClick: (date: Date) => void;
  weekDayNameFormatter: (date: Date) => JSX.Element;
  monthNameFormatter: (date: Date) => JSX.Element;
  currentMonth: Date;
  handleMonthChange: (month: Date) => void;
}

const CalendarDropdown: React.FC<CalendarDropdownProps> = ({
  calendarRef,
  isSingleDate,
  selectedSegment,
  showToast,
  toastMessage,
  range,
  tempRange,
  openCalendar,
  disabledDays,
  handleSingleDateSelect,
  handleDayClick,
  weekDayNameFormatter,
  monthNameFormatter,
  currentMonth,
  handleMonthChange,
}) => {
  return (
    <CalendarDropdownWrap
      ref={calendarRef}
      onClick={(e) => e.stopPropagation()}
      className={isSingleDate ? "single-date-mode" : ""}
    >
      {selectedSegment?.calenderHeader?.title && (
        <DatePickerHeader>
          <DatePickerHeaderInner>
            <FormattedText value={selectedSegment?.calenderHeader?.title} />
          </DatePickerHeaderInner>
        </DatePickerHeader>
      )}
      {showToast && <ErrorToast>{toastMessage}</ErrorToast>}
      {isSingleDate ? (
        <DayPicker
          mode="single"
          className={
            selectedSegment?.calenderHeader?.title ? "calenderHeader" : ""
          }
          numberOfMonths={2}
          selected={range?.from}
          disabled={disabledDays}
          onDayClick={handleSingleDateSelect}
          formatters={{
            formatWeekdayName: weekDayNameFormatter,
            formatCaption: monthNameFormatter,
          }}
          month={currentMonth}
          onMonthChange={handleMonthChange}
        />
      ) : (
        <DayPicker
          mode="range"
          numberOfMonths={2}
          selected={openCalendar === "start" ? tempRange : range}
          disabled={disabledDays}
          onDayClick={handleDayClick}
          formatters={{
            formatWeekdayName: weekDayNameFormatter,
            formatCaption: monthNameFormatter,
          }}
          month={currentMonth}
          onMonthChange={handleMonthChange}
        />
      )}
    </CalendarDropdownWrap>
  );
};

export default CalendarDropdown;
